export default __webpack_public_path__ + "static/siri-a7dc789d08ad1407f804e82bd02db3a1.mp4";